import { ReadOnlyBanner } from "../read-only-banner/ReadOnlyBanner.tsx";
import { BlockedSubscriptionBanner } from "./BlockedSubscriptionBanner.tsx";
import { SubscriptionExpirationBanner } from "./SubscriptionExpirationBanner.tsx";

export function SubscriptionBanners() {
    return (
        <>
            <SubscriptionExpirationBanner />
            <BlockedSubscriptionBanner />
            <ReadOnlyBanner />
        </>
    );
}
